// Module
var code = `<ex-multi-occurrence-analyse multi-occurrence-options="vm.rlcMultiOccurrenceOptions" multi-occurrence-out="vm.multiOccurrence"> </ex-multi-occurrence-analyse> `;
// Exports
module.exports = code;